import React from "react";

const Footer = () => {
	return (
		<div className="bg-gray-800  ">
			<div className="mx-auto max-w-7xl flex items-center justify-center md:justify-end lg:justify-end">
				<h1 className="text-gray-300 py-3 text-xs lg:text-md">
					This website is example for Fiverr Gig.
				</h1>
			</div>
		</div>
	);
};

export default Footer;
